import { Helpers } from '../../helpers';
import { IAssetType } from '../../interfaces/iasset-type';
import { Asset } from '../asset';
import { AssetSuperType } from '../asset-super-type';
import { ScenarioAssetMapping } from '../scenario-asset-mapping';

export class AssetTypeBase {
  AssetTypeId: number;
  Description: string;
  SortOrder: number | null;
  LastUpdatedDate: Date | null;
  LastUpdatedUser: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  AssetSuperTypeId: number | null;

  Assets_AssetType?: Array<Asset> | null;
  ScenarioAssetMappings_SourceAssetType?: Array<ScenarioAssetMapping> | null;
  ScenarioAssetMappings_TargetAssetType?: Array<ScenarioAssetMapping> | null;
  AssetSuperType?: AssetSuperType;

  constructor(item?: IAssetType) {
    if (item) {

      this.AssetTypeId = item.AssetTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.AssetSuperTypeId = item.AssetSuperTypeId;

      this.Assets_AssetType = Helpers.createClassArray(Asset, item.Assets_AssetType);
      this.ScenarioAssetMappings_SourceAssetType = Helpers.createClassArray(ScenarioAssetMapping, item.ScenarioAssetMappings_SourceAssetType);
      this.ScenarioAssetMappings_TargetAssetType = Helpers.createClassArray(ScenarioAssetMapping, item.ScenarioAssetMappings_TargetAssetType);
      this.AssetSuperType = new AssetSuperType(item.AssetSuperType);
    }
  }
}